/**
 * Analytics Hub — Nested sub-tab container for 4 analytics dashboards
 * Sub-tabs: Cost, Hallucination, Quality (ISA), Documentation (DocAgent)
 * Phase 4.7 — WQ-167
 */
import React, { useState, lazy, Suspense } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const CostDashboard = lazy(() => import('./CostDashboard'));
const HallucinationDashboard = lazy(() => import('./HallucinationDashboard'));
const ISAHeatmap = lazy(() => import('./ISAHeatmap'));
const DocAgentDrift = lazy(() => import('./DocAgentDrift'));

const LoadingFallback: React.FC = () => (
  <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-secondary)' }}>
    Loading dashboard...
  </div>
);

const AnalyticsHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState('cost');

  return (
    <div>
      <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginBottom: 16 }}>
        AI operations analytics — token costs, hallucination detection, agent quality, and documentation drift.
      </p>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList style={{ marginBottom: 16, position: 'sticky', top: 0, zIndex: 10, background: 'var(--bg-primary)' }}>
          <TabsTrigger value="cost">Cost</TabsTrigger>
          <TabsTrigger value="hallucination">Hallucination</TabsTrigger>
          <TabsTrigger value="quality">Quality (ISA)</TabsTrigger>
          <TabsTrigger value="documentation">Documentation</TabsTrigger>
        </TabsList>

        <TabsContent value="cost">
          <Suspense fallback={<LoadingFallback />}>
            <CostDashboard />
          </Suspense>
        </TabsContent>

        <TabsContent value="hallucination">
          <Suspense fallback={<LoadingFallback />}>
            <HallucinationDashboard />
          </Suspense>
        </TabsContent>

        <TabsContent value="quality">
          <Suspense fallback={<LoadingFallback />}>
            <ISAHeatmap />
          </Suspense>
        </TabsContent>

        <TabsContent value="documentation">
          <Suspense fallback={<LoadingFallback />}>
            <DocAgentDrift />
          </Suspense>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AnalyticsHub;
